var map = {
	"./areas/projects/components/Process/ConnectedDeploymentTargetsStatus/assets/img-feature-unassignedtargettags-dark.png": 19721,
	"./areas/projects/components/Process/ConnectedDeploymentTargetsStatus/assets/img-feature-unassignedtargettags-light.png": 80873
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62577;